import buildConfig from '../build-config.json';
import { fetch } from '../utility/fetch';
import { HTTP_STATUS } from './constants';

interface ServiceParams {
  requestId: string | null;
  productId: string | null;
}

interface Params {
  userId: string;
  serviceParams: ServiceParams;
  token: string;
  messageId: string;
  serviceName: string;
}

const buildSearchParams = (params: Params): URLSearchParams => {
  const { userId, serviceParams, token, messageId, serviceName } = params;
  const searchParams = new URLSearchParams();

  if (serviceParams.requestId !== null) {
    searchParams.set('service_params[silver_egg_request_id]', serviceParams.requestId);
  }
  if (serviceParams.productId !== null) {
    searchParams.set('service_params[product_id]', serviceParams.productId);
  }

  searchParams.set('service_user_id', userId);
  searchParams.set('token', token);
  searchParams.set('encoded_id', messageId);
  searchParams.set('service_name', serviceName);

  return searchParams;
};

export const callPostback = async (params: Params): Promise<void> => {
  if (!navigator.onLine) {
    return Promise.reject(new Error('Aborting Postback API call due to browser being offline.'));
  }

  const url = new URL(buildConfig.postbackApiUrl);
  url.search = buildSearchParams(params).toString();

  const response = await fetch(url.href, {
    headers: { 'Content-Type': 'application/json' },
    method: 'PUT',
    mode: 'cors',
  });
  if (response.status === HTTP_STATUS.BAD_REQUEST) {
    throw new Error('Postback API call failed due to passing invalid parameters.');
  }
  if (response.status === HTTP_STATUS.GONE) {
    throw new Error('Postback API call failed due to passing invalid messsage information.');
  }
  if (response.status === HTTP_STATUS.UNAUTHORIZED) {
    throw new Error('Postback API call failed due to authentication error. Check your repro token.');
  }
  if (!response.ok) {
    throw new Error(`Postback API call failed with status ${response.status}.`);
  }
  // Forwarder API へのリクエスト成功時に返ってくる
  // JSON の中身がステータスコードだけのため
  // response.json()をreturnしなくて良い
  // await response.json();
};
